import { render, staticRenderFns } from "./SidebarOverlay.vue?vue&type=template&id=8ade76a6&"
import script from "./SidebarOverlay.vue?vue&type=script&lang=js&"
export * from "./SidebarOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports